import { $api } from "libs/axios";
import Snackbar from "components-new/Snackbar";
import { findDOMNode } from "react-dom";

// Преобразовывает дату общепринятого формата на привычный. 2022-12-24 => 24.12.2022
export const convertDate = (date: string | undefined, format: string = "D.M.Y"): string | undefined => {
	if (!date) return date;

	let result = format;
	const formatter = {
		D: "$3",
		M: "$2",
		Y: "$1",
		hh: "$4",
		mm: "$5",
		ss: "$6",
	};
	let formatterKey: keyof typeof formatter;
	for (formatterKey in formatter) {
		if (format.includes(formatterKey)) {
			result = result.replace(formatterKey, formatter[formatterKey]);
		}
	}

	return date.replace(/(\d{4})-(\d{2})-(\d{2})[T|\s]?(\d{2})?:?(\d{2})?:?(\d{2})?(.*)?/g, result);
};

export function declOfLessonsNum(n: number, arr: [string, string, string]) {
	n = Math.abs(n) % 100;
	let n1 = n % 10;
	if (n > 10 && n < 20) {
		return arr[2];
	}
	if (n1 > 1 && n1 < 5) {
		return arr[1];
	}
	if (n1 === 1) {
		return arr[0];
	}
	return arr[2];
}

export function isEmpty(obj: { [key: string]: any }) {
	// noinspection LoopStatementThatDoesntLoopJS
	for (let key in obj) {
		return false;
	}
	return true;
}

export const connectNames = ({ firstName, lastName, middleName }: any) => {
	return `${lastName} ${firstName} ${middleName}`;
};
export const replacePhone = (str: any, format: "to_server" | "to_front") => {
	if (str) {
		let copyStr;
		switch (format) {
			case "to_front":
				copyStr = (str as string).replace(/\D/g, "");
				if (copyStr[0] === "7") {
					return copyStr.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/g, "+$1 ($2) $3-$4-$5");
				} else {
					return copyStr.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/g, "$1 ($2) $3-$4-$5");
				}
			case "to_server":
				copyStr = str.replace(/\D/g, "");
				if (copyStr[0] === "7") {
					return "+" + copyStr;
				} else {
					return copyStr;
				}
		}
	} else {
		return;
	}
};

export const trimString = (str: string, lower: boolean = true): string => {
	const result = str.trim();
	return lower ? result.toLowerCase() : result;
};

export const dowloadDocument = async (path: string, fileName?: string, fileType?: string, fullName?: string) => {
	try {
		return $api({
			url: path,
			method: "GET",
			responseType: "blob",
		}).then((response) => {
			const href = URL.createObjectURL(response.data);
			const link = document.createElement("a");
			link.href = href;
			link.setAttribute(
				"download",
				//  `${ fileName || "file" }.${ fileType }`
				`${fullName || fileName || "file"}${!fullName ? `.${fileType}` : ""}`,
			);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		});
	} catch ({ message }) {
		return message;
	}
};

export const findObjectById = <T extends { id: string; [key: string]: any }>(
	array: T[],
	id: string,
	searchField: keyof T,
	recursive: boolean = false,
): T | null => {
	for (let i = 0; i < array.length; i++) {
		let current = array[i];
		if (current.id === id) {
			return current;
		}
		if (recursive) {
			if (current[searchField]) {
				let result = findObjectById(current[searchField], id, searchField, recursive);
				if (result) {
					return result;
				}
			}
		}
	}
	return null;
};

export const findParent = <T extends { id: string; [key: string]: any }>(
	items: T[],
	id: string,
	searchField: keyof T,
	parent: T | null = null,
): T | null => {
	for (const item of items) {
		if (item.id === id) {
			return parent;
		}
		if (item[searchField]) {
			const found = findParent(item[searchField], id, searchField, item);
			if (found) {
				return found;
			}
		}
	}
	return null;
};

export const snackWrapper = (type: "success" | "error" | "warn" | "info", title: string) => {
	Snackbar({
		type,
		delay: 3500,
		title,
		position: "top-center",
		factor: "light",
	});
};

export const getInitialAbbreviation = (fullName: string): string => {
	const abbreviation = fullName.match(/^\p{Lu}+|\s\p{Lu}/gu) || [];

	return abbreviation.splice(0, 2).join("").toUpperCase();
};

export const findNode = (cssSelector: string) => {
	const rootNode = findDOMNode(document.body) as Element;

	const matchingElements = rootNode?.querySelectorAll(cssSelector);

	let element: Element | undefined;

	for (let i = 0; i < matchingElements.length; i++) {
		if (matchingElements[i]) {
			element = matchingElements[i];
			break;
		}
	}
	return element;
};
